// extracted by mini-css-extract-plugin
export default {"button2":"Modal_button2__dKR-8","modalbox":"Modal_modalbox__QQ0o9","header":"Modal_header__QFFwM","closebtn":"Modal_closebtn__yZemp","btnbox":"Modal_btnbox__8ZxUT"};